import { motion } from 'framer-motion';
import React from 'react';
import { FullLogoIcon } from '@/components/elements/FullLogoIcon';
import { FullLogoWhiteIcon } from '@/components/elements/FullLogoWhiteIcon';
import { buttonMotion } from '@/animations';
import ArrowIcon from '@/public/icons/arrow.svg';
import CloseIcon from '@/public/icons/close.svg';
import styles from './Left.module.scss';

// Types
interface IProps {
	goBackCallback?: () => void;
	icon?:
		| 'logo'
		| 'xmas-logo'
		| 'full-logo'
		| 'full-logo-white'
		| 'back'
		| 'close'
		| 'none';
}

// Animation
const leftMotion = {
	initial: 'initial',
	animate: 'animate',
	exit: 'exit',
	variants: {
		initial: {
			scale: 0,
			opacity: 0,
		},
		animate: {
			scale: 1,
			opacity: 1,
		},
		exit: {
			scale: 0,
			opacity: 0,
		},
	},
	transition: {
		duration: 0.25,
	},
};

export const Left = React.forwardRef(
	(
		{ icon, goBackCallback }: IProps,
		ref: React.ForwardedRef<HTMLDivElement>,
	) => {
		// Actions
		const goBackAction = () => {
			if (goBackCallback && icon !== 'logo') {
				goBackCallback();
			}
		};

		return (
			<motion.div
				ref={ref}
				className={`
					${styles['action']}
					${styles[`action_${icon}`]}
				`}
				// Animation
				{...leftMotion}
			>
				{icon === 'logo' ? (
					<FullLogoIcon
						key='LogoIcon'
						removeText
						className={`${styles['action__icon']}`}
					/>
				) : null}
				{icon === 'xmas-logo' ? (
					<FullLogoIcon
						key='xmasLogoIcon'
						xmas
						className={`${styles['action__icon']}`}
					/>
				) : null}
				{icon === 'full-logo' ? (
					<FullLogoIcon
						key='FullLogoIcon'
						className={`${styles['action__icon']}`}
					/>
				) : null}
				{icon === 'full-logo-white' ? (
					<FullLogoWhiteIcon
						key='FullLogoWhiteIcon'
						className={`${styles['action__icon']}`}
					/>
				) : null}
				{icon === 'back' ? (
					<motion.button
						type='button'
						className={styles['action__button']}
						onClick={goBackAction}
						aria-label='Go back'
						data-testid='header-go-back'
						data-e2e='close-btn'
						// Animation
						{...buttonMotion}
						custom={0.85}
					>
						<ArrowIcon
							className={`${styles['action__icon']} ${styles['action__icon_back']}`}
						/>
					</motion.button>
				) : null}
				{icon === 'close' ? (
					<motion.button
						type='button'
						className={styles['action__button']}
						onClick={goBackAction}
						aria-label='Go back'
						data-testid='header-go-back'
						data-e2e='close-btn'
						// Animation
						{...buttonMotion}
						custom={0.8}
					>
						<CloseIcon
							className={`${styles['action__icon']} ${styles['action__icon_close']}`}
						/>
					</motion.button>
				) : null}
			</motion.div>
		);
	},
);
